export const EDIT_SITE_MOTION_SETTINGS = 'editSiteMotionSettings';
export const FETCH_SITE_MOTION_SETTINGS = 'fetchSiteMotionSettings';
export const FETCH_SITE_MOTION_SETTINGS_LOCKS = 'fetchSiteMotionSettingsLocks';
export const SET_SITE_MOTION_SETTINGS = 'setSiteMotionSettings';
export const SET_SITE_MOTION_SETTINGS_LOCKS = 'setSiteMotionSettingsLocks';
